
import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { DocumentType } from 'Api/CoreApi';
//import UserInformationComponent from "Components/Base/UserInformationComponent";
import PorterBudgetStore from "Store/porterBudget/porterBudget";
@Component({
    template: "#download-pdf-button-template"
})
export class DownloadDocumentValidatorComponent extends ABaseComponent {
    displayMessage : boolean = false;
    messageStatusCode: number = -1;
    mail:string =null;
    @Prop()
    initialMail: string;
    canShowEmailError: boolean = false;
    @Prop()
    successMessage:string;


    @Prop()
    isPorter: boolean;

    get porter() {
        return PorterBudgetStore.state.porter;
    }

    get isMailValid() {
        const re = /^(([a-zA-Z0-9_'+*$%\^&!\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9:]{2,20})([,;]\W?(?!$))?)+$/;

        if (this.mail === '' || this.mail === null || this.mail === "" || this.mail === undefined || this.mail === 'undefined') {
            return false;
        }

        return re.test(String(this.mail).toLowerCase());
    }

    get emailSuccessMessage() {
        return this.successMessage.replace("#EMAIL_PLACE_HOLDER#", this.mail);
    }

    created(){
        this.setLoaded();    
        this.$on('show-download-message', this.showMessage);
        this.mail = this.initialMail;
        this.canShowEmailError = true;
    }

    async mounted() {
        if (this.isPorter) {
            await PorterBudgetStore.dispatchFetchPorter()
            this.mail = this.porter.email;
        }
    }

    download(url: string, evt: Event) {
        var url = url + '&email=' + this.mail;
        this.setDisabledAndLoading(<HTMLElement>evt.target,true);
        $.get(url).then((returnVal,statusText,xhr,mail)=>{
            this.messageStatusCode = xhr.status;
            this.showMessage();
            this.setDisabledAndLoading(<HTMLElement>evt.target,false);
        });   
        
    }
    disableTemporarily(evt:Event){
        this.setDisabledAndLoading(<HTMLElement>evt.target,true);
        setTimeout(()=>{
            this.setDisabledAndLoading(<HTMLElement>evt.target,false);
        },10000);
         
    }
    showMessage(statusCode? : number){
        if(statusCode)
            this.messageStatusCode = statusCode;
        this.displayMessage = true;
        setTimeout(()=>{
            this.displayMessage = false;
        },10000);
    }

    setDisabledAndLoading(elem : HTMLElement,isDisabled:boolean){
        if(isDisabled){
            elem.classList.add("loading");
            elem.setAttribute("disabled",isDisabled.toString().toLowerCase());
        }else{
            elem.classList.remove("loading");
            elem.removeAttribute("disabled");
        }
    }
    
}

Vue.component('download-document-validator', DownloadDocumentValidatorComponent);
